import { create } from "zustand";
import { persist } from "zustand/middleware";

interface ApiConfigStore {
  isDev: boolean;
  devApiUrl: string;
  setIsDev: (isDev: boolean) => void;
  setDevApiUrl: (url: string) => void;
  getApiUrl: () => string;
}

export const useApiConfigStore = create<ApiConfigStore>()(
  persist(
    (set, get) => ({
      isDev: false,
      devApiUrl: "http://127.0.0.1:8000",

      setIsDev: (isDev: boolean) => set({ isDev }),

      setDevApiUrl: (url: string) => set({ devApiUrl: url }),

      getApiUrl: () => {
        const state = get();
        return state.isDev
          ? state.devApiUrl
          : process.env.REACT_APP_API_URL || "https://api.example.com";
      },
    }),
    {
      name: "api-config-storage",
    },
  ),
);
